import React from 'react';

export default function MobileModal(props: any) {

    return (
        <>
            <div className="not-support-page">
                <div className="not-support-content">
                    <img className="not-support-photo-1" src="https://khicindekocvar.blob.core.windows.net/cdn/prod/mobile-warning.svg" />
                    <h3 className="title">Koç Moments her an elinin altında!</h3>
                    <p className="description" id="transition-modal-description">
                        Koç Moments, Koç Topluluğu şirketlerindeki yöneticileri, ekiplerindeki çalışma arkadaşları için önemli olan günlerden haberdar
                        eden özel bir hatırlatıcı uygulamadır. Kullanım yetkisi verilmiş ekip liderleri, e-posta adresleri ve şifreleri ile hem web
                        sitesinden hem de mobil uygulama üzerinden erişilebilir
                        <br />
                    </p>
                    <div className="wrapper">
                        <a href="https://apps.apple.com/app/koç-moments/id1623384924">
                            <img className="c-item-01" src="https://khicindekocvar.blob.core.windows.net/cdn/prod/app-store.png" />
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.koc.moments">
                            <img className="c-item-02" src="https://khicindekocvar.blob.core.windows.net/cdn/prod/android-store.png" />
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
}
